import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { HttpEventType } from "@angular/common/http";
import Swal from "sweetalert2";
import { Utils } from "../../../../../shared/utils/Utils";
import { CargosService } from "../../../../../shared/services/cargos.service";
import { PasoActividadPlanService } from "../../../../../shared/services/Pasoactividadplan.service";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { DigitalesService } from "../../../../../shared/services/digitales.service";

// ===== Tabla INTERMEDIA: vincula paso real + plan (GestionId) =====
import {
  ActividadPasosPlan,
  ActividadPasosPlanPayload,
  ActividadPasosPlanService,
} from "../../../../../shared/services/actividad-pasos-plan.service";

// ===== Tabla PRINCIPAL: contiene el contenido real (actividad, responsable, fechas) =====
import {
  ActividadPasosPlanre,
  ActividadPasosPlanrePayload,
  ActividadPasosPlanreService,
} from "../../../../../shared/services/actividad-pasos-planre.service";

// ===== Seguimiento por actividad =====
import {
  SeguimientoActividad,
  SeguimientoActividadPayload,
  SeguimientoActividadService,
} from "../../../../../shared/services/seguimiento-actividad.service";
import { PropietarioService } from "../../../../../shared/services/propietarios.service";

interface DocumentoAdjunto {
  path: string;
  name: string;
  url: string;
  isImage: boolean;
}

interface ArchivoPendiente {
  file: File;
  preview: string | null;
}

interface DocumentoPreview {
  name: string;
  path: string;
  url: string;
  urlSegura?: SafeResourceUrl;
  isImage: boolean;
  isPdf: boolean;
  tipo: string;
}

const EXTENSIONES_IMAGEN = ["jpg", "jpeg", "png", "webp"];
const MIME_IMAGEN = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

@Component({
  selector: "app-pasos-plan",
  templateUrl: "./pasos-plan.component.html",
  styleUrls: ["./pasos-plan.component.scss"],
})
export class PasosPlanComponent implements OnInit {
  GestionId!: number;
  cargandoLista = false;
  activeTab = 1;
  cargosDisponibles: any[] = [];
  listaPasos: any[] = [];
  listaVinculos: ActividadPasosPlan[] = [];
  pageActividades = 1;
  pageSizeActividades = 5;

  actividadEditando: any | null = null;
  actividadesForm!: FormGroup;
  guardandoActividades = false;

  // ✅ Propiedad normal (NO getter): se calcula una sola vez cuando llegan/cambian los datos.
  // Un getter aquí haría que Angular regenerara objetos nuevos en cada ciclo de detección
  // de cambios, rompiendo la identidad de las filas del *ngFor y provocando que los clicks
  // no "aterricen" en los botones (parece que no responden).
  pasosAgrupados: {
    id_paso_real: number;
    nombrePaso: string;
    filas: { grupo: any; act: any }[];
  }[] = [];

  // ==========================================================
  // SEGUIMIENTOS DE LA ACTIVIDAD: listado + formulario crear/editar
  // ==========================================================
  actividadSeguimientoActual: any | null = null;
  listaSeguimientos: SeguimientoActividad[] = [];
  cargandoSeguimientos = false;

  seguimientoForm!: FormGroup;
  seguimientoEditando: SeguimientoActividad | null = null;
  guardandoSeguimiento = false;

  // ==========================================================
  // DOCUMENTOS DEL SEGUIMIENTO SELECCIONADO
  // ==========================================================
  nit: string | null = null;
  administraciones: any[] = [];

  seguimientoSeleccionadoDocs: SeguimientoActividad | null = null;
  documentosPlan: DocumentoAdjunto[] = [];
  nuevosArchivosDocs: ArchivoPendiente[] = [];
  cargandoDocumentos = false;
  subiendoDocumentos = false;

  /** Documento actualmente previsualizado dentro del modal de documentos. */
  documentoSeleccionado: DocumentoPreview | null = null;
  /** Controla si el modal de documentos muestra la lista o la previsualización. */
  mostrandoPreviewDocumento = false;
  Responsable: any[] = [];


 constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private pasoActividadPlanService: PasoActividadPlanService,
    private actividadPasosPlanService: ActividadPasosPlanService,
    private actividadPasosPlanreService: ActividadPasosPlanreService,
    private cargosService: CargosService,
    private seguimientoActividadService: SeguimientoActividadService,
    private administracionesServices: AdministracionService,
    private digitalesService: DigitalesService,
    private propietarioService: PropietarioService
  ) {}

  ngOnInit(): void {
    this.GestionId = Number(this.route.snapshot.paramMap.get("id"));

    this.inicializarFormActividad();
    this.inicializarFormSeguimiento();
    this.cargarCargos();
    this.cargarPasos();
    this.cargarVinculos();
    this.cargarAdministraciones();
    this.cargarResponsable();
  }
  // ==================================================================
  // CATÁLOGOS DE APOYO
  // ==================================================================

  cargarCargos(): void {
    this.cargosService.getCargosActivos().subscribe({
      next: (data) => {
        this.cargosDisponibles = data;
      },
    });
  }

  cargarPasos(): void {
    this.pasoActividadPlanService.getAll().subscribe({
      next: (data) => {
        this.listaPasos = data;
      },
    });
  }

cargarResponsable(): void {

  this.propietarioService.getPlanAccion().subscribe({

    next: (response: any) => {

      console.log('RESPUESTA RESPONSABLES:', response);

      const data: any[] = Array.isArray(response)
        ? response
        : response?.data || [];

      this.Responsable = data.map((r: any) => {

        const nombre = [
          r.primernombre,
          r.segundonombre,
          r.papellidos,
          r.seapellidos
        ]
          .filter((x: any) => x)
          .join(' ')
          .trim();

        const cargo =
          r.cargoData?.cargos ||
          r.cargoData?.cargo ||
          r.cargo ||
          r.cargos ||
          'Sin cargo';

        return {
          ...r,

          nombreConCargo:
            `${nombre || r.nombreCompleto || 'Sin nombre'} - (${cargo})`
        };
      });

      console.log(
        'RESPONSABLES PROCESADOS:',
        this.Responsable
      );
    },

    error: (error) => {

      console.error(
        'ERROR CARGANDO RESPONSABLES:',
        error
      );

      this.Responsable = [];
    }
  });
}

  // ==================================================================
  // ÚNICA carga: vínculos + paso + actividades, tal cual los entrega el backend
  // ==================================================================

  cargarVinculos(): void {
    this.cargandoLista = true;
    this.actividadPasosPlanService.getByIdPlan(this.GestionId).subscribe({
      next: (data) => {
        this.listaVinculos = data;
        this.calcularPasosAgrupados(); // 👈 se recalcula UNA vez, no en cada ciclo de CD
        this.cargandoLista = false;
      },
      error: () => {
        this.cargandoLista = false;
      },
    });
  }

  obtenerNombreCargo(id: number): string {
    return this.cargosDisponibles.find((c) => c.id === id)?.cargos || "-";
  }

  // ==================================================================
  // FORM: ACTIVIDADES (creación múltiple + edición por grupo de paso)
  // ==================================================================

  inicializarFormActividad(): void {
    this.actividadesForm = this.fb.group({
      id_paso: [null, [Validators.required]], // paso REAL seleccionado en el ng-select
      actividades: this.fb.array([this.crearItemActividad()]),
    });
  }

  crearItemActividad(
    id?: number,
    actividad: string = "",
    responsable: number | null = null,
    fecha_programada: any = "",
  ): FormGroup {
    return this.fb.group({
      id: [id || null], // id del registro en PLANRE
      actividad: [actividad, [Validators.required, Validators.maxLength(3000)]],
      responsable: [responsable, [Validators.required]],
      fecha_programada: [fecha_programada, [Validators.required]],
    });
  }

  get actividadesArray(): FormArray {
    return this.actividadesForm.get("actividades") as FormArray;
  }

  agregarFilaActividad(): void {
    this.actividadesArray.push(this.crearItemActividad());
  }

  eliminarFilaActividad(index: number): void {
    if (this.actividadesArray.length === 1) {
      this.actividadesArray.at(0).reset({
        id: null,
        actividad: "",
        responsable: null,
        fecha_programada: "",
      });
      return;
    }
    this.actividadesArray.removeAt(index);
  }

  private reiniciarFormActividades(): void {
    this.actividadesForm.reset();
    const array = this.actividadesArray;
    array.clear();
    array.push(this.crearItemActividad());
  }

  // ==================================================================
  // MODAL: abrir para crear o editar
  // Recibe la FILA ({ grupo, act }) proveniente del *ngFor de la tabla.
  // ==================================================================

  abrirModalActividad(modalRef: any, fila?: { grupo: any; act: any }): void {
    this.actividadEditando = fila || null;
    this.reiniciarFormActividades();

    if (fila?.act) {
      this.actividadesForm.patchValue({ id_paso: fila.grupo.id_paso });

      const array = this.actividadesArray;
      array.clear();
      array.push(
        this.crearItemActividad(
          fila.act.id,
          fila.act.actividad,
          fila.act.responsable,
          fila.act.fecha_programada,
        ),
      );
    }

    this.modalService.open(modalRef, { size: "xl", backdrop: "static" });
  }

  // ==================================================================
  // GUARDAR: 1) vínculo (plan) → 2) actividades (planre)
  // ==================================================================

  async guardarTodasActividades(modal?: any): Promise<void> {
    if (this.actividadesForm.invalid) {
      this.actividadesForm.get("id_paso")?.markAsTouched();
      this.actividadesArray.controls.forEach((c) => c.markAllAsTouched());
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Seleccione el paso y complete todas las actividades antes de guardar.",
      });
      return;
    }

    if (!this.GestionId) {
      Swal.fire({
        icon: "error",
        title: "Falta el plan",
        text: "No se encontró el ID del plan en la ruta.",
      });
      return;
    }

    const valores = this.actividadesForm.value;
    const pasoSeleccionado = valores.id_paso; // paso REAL
    const items = valores.actividades.filter(
      (item: any) => (item.actividad || "").trim().length > 0,
    );

    if (items.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nada para guardar",
        text: "Ingrese al menos una actividad válida.",
      });
      return;
    }

    this.guardandoActividades = true;

    try {
      const resultados = await Promise.allSettled(
        items.map(async (item: any) => {
          let idVinculo: number;

          if (item.id) {
            // Editando una actividad existente: reutiliza SU vínculo actual (no crea uno nuevo)
            const fila = this.buscarFilaPorIdActividad(item.id);
            idVinculo = fila?.grupo?.id;

            if (!idVinculo) {
              throw new Error(
                "No se encontró el vínculo de la actividad a editar.",
              );
            }
          } else {
            // 👇 Actividad NUEVA: SIEMPRE se crea su propio vínculo (1 vínculo = 1 actividad)
            const payloadVinculo: ActividadPasosPlanPayload = {
              id_paso: pasoSeleccionado, // paso REAL
              id_plan: this.GestionId,
              estado: 1,
            };

            const respuestaVinculo: any = await this.actividadPasosPlanService
              .create(payloadVinculo)
              .toPromise();
            idVinculo = respuestaVinculo?.data?.id || respuestaVinculo?.id;

            if (!idVinculo) {
              throw new Error("No se pudo crear el vínculo de la actividad.");
            }
          }

          const payloadComun = {
            id_paso: idVinculo, // 👈 el ID del vínculo (1 por actividad)
            actividad: item.actividad.trim(),
            responsable: item.responsable,
            fecha_programada: item.fecha_programada,
          };

          return item.id
            ? this.actividadPasosPlanreService
                .update(item.id, payloadComun)
                .toPromise()
            : this.actividadPasosPlanreService
                .create({
                  ...payloadComun,
                  estado: 1,
                } as ActividadPasosPlanrePayload)
                .toPromise();
        }),
      );

      const exitosos = resultados.filter(
        (r) => r.status === "fulfilled",
      ).length;
      const fallidos = resultados.filter((r) => r.status === "rejected").length;

      this.guardandoActividades = false;
      this.reiniciarFormActividades();
      this.cargarVinculos();
      if (modal) modal.close();

      if (fallidos === 0) {
        Swal.fire({
          icon: "success",
          title: this.actividadEditando
            ? "Actividades actualizadas"
            : "Actividades guardadas",
          text: `Se procesaron ${exitosos} actividad(es) correctamente.`,
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Guardado parcial",
          text: `${exitosos} guardadas, ${fallidos} fallaron.`,
        });
      }
    } catch (err) {
      this.guardandoActividades = false;
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo guardar la actividad.",
      });
    }
  }

  // ==================================================================
  // CAMBIAR ESTADO
  // ==================================================================

  cambiarEstadoActividad(actividad: ActividadPasosPlanre): void {
    if (!actividad.id) return;
    const accion = actividad.estado === 1 ? "inactivar" : "activar";

    Swal.fire({
      icon: "question",
      title: `¿${accion === "inactivar" ? "Inactivar" : "Activar"} actividad?`,
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const peticion =
        accion === "inactivar"
          ? this.actividadPasosPlanreService.inactivar(actividad.id!)
          : this.actividadPasosPlanreService.activar(actividad.id!);

      peticion.subscribe({
        next: () => {
          this.cargarVinculos();
          Swal.fire({
            icon: "success",
            title: "Estado actualizado",
            timer: 1200,
            showConfirmButton: false,
          });
        },
        error: () =>
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo cambiar el estado.",
          }),
      });
    });
  }

  cambiarEstadoGrupo(grupo: any, activar: boolean): void {
    const actividades: ActividadPasosPlanre[] =
      grupo?.ActividadPasosPlanreData || [];

    Swal.fire({
      icon: "question",
      title: `¿${activar ? "Activar" : "Inactivar"} este paso?`,
      text: activar
        ? "Se activará el paso y todas sus actividades."
        : "Se inactivará el paso y todas sus actividades.",
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const peticiones: Promise<any>[] = [];

      // Cambiar estado del grupo (ActividadPasosPlan)
      if (grupo.id) {
        peticiones.push(
          (activar
            ? this.actividadPasosPlanService.activar(grupo.id)
            : this.actividadPasosPlanService.inactivar(grupo.id)
          ).toPromise(),
        );
      }

      // Cambiar estado de todas las actividades (ActividadPasosPlanre)
      actividades.forEach((actividad) => {
        if (actividad.id) {
          peticiones.push(
            (activar
              ? this.actividadPasosPlanreService.activar(actividad.id)
              : this.actividadPasosPlanreService.inactivar(actividad.id)
            ).toPromise(),
          );
        }
      });

      Promise.allSettled(peticiones)
        .then(() => {
          this.cargarVinculos();

          Swal.fire({
            icon: "success",
            title: activar ? "Paso activado" : "Paso inactivado",
            text: activar
              ? "El paso y sus actividades fueron activados."
              : "El paso y sus actividades fueron inactivados.",
            timer: 1500,
            showConfirmButton: false,
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo cambiar el estado del paso.",
          });
        });
    });
  }

  // ==================================================================
  // EXPORTACIÓN
  // ==================================================================

  exportarExcel(tablaId: string, nombreArchivo: string): void {
    Utils.exportVisibleTableToExcel(tablaId, nombreArchivo);
  }

  exportToPDF(tablaId: string, nombreArchivo: string, titulo: string): void {
    Utils.exportToPDF(tablaId, nombreArchivo, titulo);
  }

  // ==================================================================
  // AGRUPACIÓN POR PASO REAL (para reconstruir visualmente el listado
  // agrupado, ya que ahora cada actividad tiene su propio vínculo)
  // ==================================================================

  private calcularPasosAgrupados(): void {
    const mapa = new Map<
      number,
      {
        id_paso_real: number;
        nombrePaso: string;
        filas: { grupo: any; act: any }[];
      }
    >();

    for (const grupo of this.listaVinculos) {
      const idPasoReal = grupo.id_paso;
      const nombrePaso = grupo.PasoActividadPlanData?.paso || "-";

      if (!mapa.has(idPasoReal)) {
        mapa.set(idPasoReal, {
          id_paso_real: idPasoReal,
          nombrePaso,
          filas: [],
        });
      }

      const entradaPaso = mapa.get(idPasoReal)!;

      const actividades = grupo.ActividadPasosPlanreData || [];

      if (actividades.length === 0) {
        entradaPaso.filas.push({
          grupo,
          act: null,
        });
      } else {
        actividades.forEach((act: any) => {
          entradaPaso.filas.push({
            grupo,
            act,
          });
        });
      }
    }

    this.pasosAgrupados = Array.from(mapa.values());
  }

  private buscarFilaPorIdActividad(
    idActividadPlanre: number,
  ): { grupo: any; act: any } | null {
    for (const grupo of this.listaVinculos) {
      const act = (grupo.ActividadPasosPlanreData || []).find(
        (a: any) => a.id === idActividadPlanre,
      );
      if (act) return { grupo, act };
    }
    return null;
  }

  // ==========================================================
  // ================  SEGUIMIENTOS DE ACTIVIDAD  ============
  // ==========================================================

  inicializarFormSeguimiento(): void {
    this.seguimientoForm = this.fb.group({
      observacion: ["", [Validators.required, Validators.maxLength(3000)]],
    });
  }

  abrirModalSeguimientos(modalRef: any, actividad: any): void {
    if (!actividad?.id) return;

    this.actividadSeguimientoActual = actividad;
    this.cargarSeguimientos(actividad.id);

    this.modalService.open(modalRef, { size: "lg", backdrop: "static" });
  }

cargarSeguimientos(idActividad: number): void {
    this.cargandoSeguimientos = true;
    this.seguimientoActividadService.getByIdActividad(idActividad).subscribe({
      next: (data: any) => {
        this.listaSeguimientos = Array.isArray(data) ? data : data?.data || [];
        this.cargandoSeguimientos = false;
      },
      error: () => {
        this.listaSeguimientos = [];
        this.cargandoSeguimientos = false;
      },
    });
  }

  trackBySeguimientoId(_index: number, seguimiento: any): number | undefined {
    return seguimiento.id;
  }


 abrirModalSeguimientoForm(modalRef: any, seguimiento?: any): void {
    this.seguimientoEditando = seguimiento || null;
    this.seguimientoForm.reset();

    if (seguimiento) {
      this.seguimientoForm.patchValue({ observacion: seguimiento.observacion });
    }

    this.modalService.open(modalRef, { size: "lg", backdrop: "static" });
  }
  guardarSeguimiento(modal: any): void {
    if (this.seguimientoForm.invalid) {
      this.seguimientoForm.markAllAsTouched();
      return;
    }
    if (!this.actividadSeguimientoActual?.id) {
      Swal.fire({ icon: "error", title: "Error", text: "No se identificó la actividad asociada." });
      return;
    }

    this.guardandoSeguimiento = true;
    const idActividad = this.actividadSeguimientoActual.id;
    const observacion = (this.seguimientoForm.value.observacion || "").trim();

    const peticion = this.seguimientoEditando?.id
      ? this.seguimientoActividadService.update(this.seguimientoEditando.id, {
          id_actividad: idActividad,
          observacion,
        })
      : this.seguimientoActividadService.create({
          id_actividad: idActividad,
          observacion,
          estado: 1,
        });

    const mensajeExito = this.seguimientoEditando ? "Seguimiento actualizado" : "Seguimiento guardado";

    peticion.subscribe({
      next: () => {
        this.guardandoSeguimiento = false;
        modal.close();
        this.cargarSeguimientos(idActividad);
        this.cargarVinculos();
        Swal.fire({ icon: "success", title: mensajeExito, timer: 1500, showConfirmButton: false });
      },
      error: () => {
        this.guardandoSeguimiento = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo guardar el seguimiento." });
      },
    });
  }

  cambiarEstadoSeguimiento(seguimiento: any): void {
    if (!seguimiento.id || !this.actividadSeguimientoActual?.id) return;
    const idActividad = this.actividadSeguimientoActual.id;
    const accion = seguimiento.estado === 1 ? "Inactivar" : "Activar";

    Swal.fire({
      icon: "question",
      title: `¿${accion} seguimiento?`,
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const peticion =
        seguimiento.estado === 1
          ? this.seguimientoActividadService.inactivar(seguimiento.id)
          : this.seguimientoActividadService.activar(seguimiento.id);

      peticion.subscribe({
        next: () => {
          this.cargarSeguimientos(idActividad);
          this.cargarVinculos();
          Swal.fire({ icon: "success", title: "Estado actualizado", timer: 1200, showConfirmButton: false });
        },
        error: () =>
          Swal.fire({ icon: "error", title: "Error", text: "No se pudo cambiar el estado." }),
      });
    });
  }

  // ==================================================================
  // DOCUMENTOS DEL SEGUIMIENTO (mismo patrón que seguimientos_meta / SGM)
  // ==================================================================

  private cargarAdministraciones(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data: any[]) => {
        this.administraciones = data ?? [];
        this.nit = this.administraciones?.[0]?.nit ?? null;
      },
      error: () => {
        this.administraciones = [];
        this.nit = null;
      },
    });
  }

  abrirModalDocumentosSeguimiento(modalRef: any, seguimiento: any): void {
    if (!this.nit) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Aún se está cargando la información de la administración. Intente de nuevo en un momento.",
      });
      return;
    }

    this.seguimientoSeleccionadoDocs = seguimiento;
    this.nuevosArchivosDocs = [];
    this.documentosPlan = [];
    this.mostrandoPreviewDocumento = false;
    this.documentoSeleccionado = null;
    this.cargarDocumentosSeguimiento(seguimiento);

    this.modalService.open(modalRef, { size: "lg", centered: true, backdrop: "static" });
  }

  cargarDocumentosSeguimiento(seguimiento: any): void {
    if (!this.nit) return;

    this.cargandoDocumentos = true;
    const rutaCompleta = this.construirRutaSeguimientoActividad(seguimiento);

    this.digitalesService.getDocumentosPlanAccion(rutaCompleta).subscribe({
      next: (resp) => {
        this.documentosPlan = (resp.archivos ?? []).map((a: any) => ({
          name: a.name,
          path: a.path,
          url: a.url,
          isImage: this.esImagenPorNombre(a.name),
        }));
        this.cargandoDocumentos = false;
      },
      error: () => {
        this.documentosPlan = [];
        this.cargandoDocumentos = false;
      },
    });
  }

  onFileChangeDocumento(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.nuevosArchivosDocs.push({
          file,
          preview: this.isImageFile(file) ? e.target.result : null,
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = "";
  }

  quitarArchivoNuevo(index: number): void {
    this.nuevosArchivosDocs.splice(index, 1);
  }

  subirDocumentosSeguimiento(): void {
    const seguimiento = this.seguimientoSeleccionadoDocs;
    if (!seguimiento || seguimiento.estado === 0 || this.nuevosArchivosDocs.length === 0 || !this.nit) {
      return;
    }

    this.subiendoDocumentos = true;
    const rutaCompleta = this.construirRutaSeguimientoActividad(seguimiento);
    const pendientes = this.nuevosArchivosDocs.length;
    let completados = 0;

    this.nuevosArchivosDocs.forEach((item, index) => {
      const nombreSinExtension = item.file.name.replace(/\.[^/.]+$/, "");
      const sufijoUnico = `${Date.now()}_${index}_${Math.floor(Math.random() * 10000)}`;
      const nombreArchivo = `${nombreSinExtension}_${sufijoUnico}`;

      this.digitalesService.subirDocumentoPlanAccion(item.file, rutaCompleta, nombreArchivo, "SGA").subscribe({
        next: (event) => {
          if (event.type === HttpEventType.Response) {
            completados++;
            if (completados === pendientes) {
              this.subiendoDocumentos = false;
              this.nuevosArchivosDocs = [];
              this.cargarDocumentosSeguimiento(seguimiento);
              Swal.fire({ icon: "success", title: "¡Éxito!", text: "Documento(s) subido(s) correctamente." });
            }
          }
        },
        error: () => {
          completados++;
          this.subiendoDocumentos = false;
          if (completados === pendientes) {
            this.cargarDocumentosSeguimiento(seguimiento);
          }
          Swal.fire({ icon: "error", title: "Error", text: `No se pudo subir el archivo ${item.file.name}.` });
        },
      });
    });
  }

  eliminarDocumentoSeguimiento(doc: DocumentoAdjunto): void {
    const seguimiento = this.seguimientoSeleccionadoDocs;
    if (!seguimiento || seguimiento.estado === 0) {
      Swal.fire({
        icon: "warning",
        title: "Acción no permitida",
        text: "No se puede eliminar documentos de un seguimiento inactivo.",
      });
      return;
    }

    Swal.fire({
      title: "¿Eliminar documento?",
      text: `¿Está seguro de que desea eliminar "${doc.name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.digitalesService.eliminarArchivo(doc.path).subscribe({
        next: () => {
          this.cargarDocumentosSeguimiento(seguimiento);
          Swal.fire({ icon: "success", title: "¡Éxito!", text: "El documento se eliminó correctamente." });
        },
        error: () => {
          Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar el documento." });
        },
      });
    });
  }

  reemplazarDocumentoSeguimiento(doc: DocumentoAdjunto): void {
    const seguimiento = this.seguimientoSeleccionadoDocs;
    if (!seguimiento || seguimiento.estado === 0) {
      Swal.fire({
        icon: "warning",
        title: "Acción no permitida",
        text: "No se puede reemplazar documentos de un seguimiento inactivo.",
      });
      return;
    }

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".pdf,.jpg,.jpeg,.png,.webp";

    input.onchange = (event: any) => {
      const file: File = event.target.files[0];
      if (!file) return;

      Swal.fire({
        title: "¿Reemplazar documento?",
        text: `Se reemplazará "${doc.name}" por "${file.name}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, reemplazar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.subiendoDocumentos = true;

        this.digitalesService.eliminarArchivo(doc.path).subscribe({
          next: () => {
            const rutaCompleta = this.construirRutaSeguimientoActividad(seguimiento);
            const indice = this.documentosPlan.findIndex((d) => d.path === doc.path) + 1;
            const nombreArchivo = `${seguimiento.id}_${indice}`;

            this.digitalesService.subirDocumentoPlanAccion(file, rutaCompleta, nombreArchivo, "SGA").subscribe({
              next: (event) => {
                if (event.type === HttpEventType.Response) {
                  this.subiendoDocumentos = false;
                  this.cargarDocumentosSeguimiento(seguimiento);
                  Swal.fire({ icon: "success", title: "¡Éxito!", text: "Documento reemplazado correctamente." });
                }
              },
              error: () => {
                this.subiendoDocumentos = false;
                Swal.fire({ icon: "error", title: "Error", text: "No se pudo subir el nuevo documento." });
              },
            });
          },
          error: () => {
            this.subiendoDocumentos = false;
            Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar el documento anterior." });
          },
        });
      });
    };

    input.click();
  }

  verDocumento(doc: DocumentoAdjunto): void {
    if (!doc.url) return;

    const tipo = this.obtenerTipoDocumento(doc.name);

    this.documentoSeleccionado = {
      ...doc,
      isImage: tipo === "imagen",
      isPdf: tipo === "pdf",
      tipo,
      urlSegura: tipo === "pdf" ? this.sanitizer.bypassSecurityTrustResourceUrl(doc.url) : undefined,
    };

    this.mostrandoPreviewDocumento = true;
  }

  cerrarPreviewDocumento(): void {
    this.mostrandoPreviewDocumento = false;
    this.documentoSeleccionado = null;
  }

  private construirRutaSeguimientoActividad(seguimiento: any): string {
    const idActividad = this.actividadSeguimientoActual?.id;
    const carpeta = `pesv/pasosPlan/seguimiento/${idActividad}/${seguimiento.id}`;
    return `${this.nit}/${carpeta}`;
  }

  private esImagenPorNombre(nombre: string): boolean {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    return EXTENSIONES_IMAGEN.includes(ext);
  }

  private isImageFile(file: File): boolean {
    return MIME_IMAGEN.includes(file.type);
  }

  private obtenerTipoDocumento(nombre: string): "imagen" | "pdf" | "word" | "excel" | "otro" {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    if (EXTENSIONES_IMAGEN.includes(ext)) return "imagen";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";
    return "otro";
  }
}